import { render, staticRenderFns } from "./VariantSifterGenesDrawer.vue?vue&type=template&id=fdc787b2&scoped=true&"
import script from "./VariantSifterGenesDrawer.vue?vue&type=script&lang=js&"
export * from "./VariantSifterGenesDrawer.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterGenesDrawer.vue?vue&type=style&index=0&id=fdc787b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc787b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdc787b2')) {
      api.createRecord('fdc787b2', component.options)
    } else {
      api.reload('fdc787b2', component.options)
    }
    module.hot.accept("./VariantSifterGenesDrawer.vue?vue&type=template&id=fdc787b2&scoped=true&", function () {
      api.rerender('fdc787b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterGenesDrawer.vue"
export default component.exports